import styled from 'styled-components';
import {
  blackSphera,
  brandBlack,
  brandYellowgreen,
  neutralBlueGray,
  whiteSphera
} from 'src/utilities/UIStyles/variables/Colors';
import { neutralLight } from 'src/utilities/UIStyles/variables/Colors';
import { greenSp } from 'src/utilities/UIStyles/variables/Colors';

export const DetailContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 2%;
`;

export const MainDetail = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  width: 90%;
  margin: 2% 5%;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  > a {
    text-decoration: none;
    text-align: center;
    color: ${neutralBlueGray};
    border-radius: 5px;
    font-size: 1.2vw;
    font-weight: bold;
    cursor: pointer;
    padding: 1% 0;
    width: auto;
    align-self: flex-start;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    > a {
      font-size: 3.5vw;
    }
  }
`;

export const CardLogo = styled.figure`
  width: 15%;
  height: auto;
  margin: 0 2%;
  > img {
    width: 100%;
    height: 100%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    width: 60%;
    height: auto;
    > img {
    }
  }
`;

export const InvestDetail = styled.figure`
  width: 70%;
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 50%;
    > h2 {
      color: ${brandBlack};
      font-weight: bold;
      font-size: 2vw;
    }
    > p {
      color: ${brandBlack};
      font-size: 1.2vw;
      margin: 2% 0;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      width: 50%;
    }
  }
  @media (max-width: 600px) {
    width: 90%;
    margin: 2% 5%;
    > div {
      width: 90%;
      margin: 0 5%;
      text-align: center;
      > h2 {
        font-size: 3.5vw;
      }
      > p {
        font-size: 3vw;
      }
    }
  }
`;

export const Simulator = styled.div`
  background-color: ${brandBlack};
  color: ${whiteSphera};
  width: 45%;
  margin: 2% 2.5%;
  > h2 {
    text-align: center;
  }
`;

export const CardStatus = styled.div`
  width: 100%;
  padding: 5% 10%;
  > h3 {
    text-align: center;
    font-size: 1vw;
    font-weight: bold;
    color: ${brandBlack};
    margin-bottom: 5%;
  }
  > div {
    width: 100%;
    height: 20px;
    border-radius: 10px;
    background-color: #f0f5ff;
    > div {
      width: ${(props) => props.percentage && `${props.percentage}%`};
      height: 100%;
      border-radius: 10px;
      background-color: ${brandYellowgreen};
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    > h3 {
      font-size: 4vw;
    }
  }
`;

export const CampaignInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: 10px;
  /* border: 1px solid ${brandBlack}; */
  width: 45%;
  margin: 2% auto;
  padding: 0 2% 2% 2%;
  font-size: 1vw;
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    width: 100%;
    > h3 {
      font-size: 4vw;
    }
  }
`;

export const GeneralInfo = styled.div`
  width: 50%;
  padding: 3% 1%;
  background-color: ${neutralLight};
  > h2 {
    margin-top: 5%;
    font-size: 1.3vw;
  }
  > h3 {
    margin-top: 5%;
    font-size: 1.3vw;
  }
  > p {
    font-size: 1.2vw;
    margin-bottom: 3%;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    width: 90%;
    margin: 0 5%;
    > h2 {
      font-size: 2.6vw;
    }
    > h3 {
      font-size: 2.6vw;
    }
    > p {
      font-size: 2.6vw;
    }
  }
`;

export const InterestInfo = styled.div`
  width: 45%;
  > h2 {
    border-bottom: 1px solid ${blackSphera};
    margin-bottom: 3%;
    color: ${greenSp};
    font-size: 1.3vw;
  }
  > p {
    font-size: 1.2vw;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    width: 90%;
    margin: 0 5%;
    > h2 {
      font-size: 2.6vw;
    }
    > p {
      font-size: 2.6vw;
    }
  }
`;
